<template>
  <div v-if="errorMessage" class="global-error">
    <p class="global-error-message">
      {{ errorMessage }}
    </p>
  </div>
</template>

<script>
export default {
  name: "GlobalError",
  props: {
    errorMessage: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
.global-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;

  padding: 16px;

  background: #a12525;
  border-radius: 6px;

  color: white;
}

.global-error-message {
  @include font-family("body");
  @include scale-fonts("form-label");

  width: 100%;
}
</style>
